import { FilterData, FilterSourceData, FilterSourceItem } from "../typing";
import { getBanksByBrand } from "../utils";

const brandFilterFn = (data: FilterSourceItem, value: FilterData["brand"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.includes(data.brand);
};
const subBrandFilterFn = (data: FilterSourceItem, value: FilterData["subBrand"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.includes(data.sub_brand);
};

const nameFilterFn = (data: FilterSourceItem, value: FilterData["name"]): boolean => {
  if (!value) {
    return true;
  }
  return (
    data.name.toLowerCase().includes(value.toLowerCase()) ||
    data.formatted_address.toLowerCase().includes(value.toLowerCase())
  );
};

const banksFilterFn = (data: FilterSourceItem, value: FilterData["banks"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  const banks = getBanksByBrand(data.brand);
  return banks.some((v) => value.includes(v));
};

const pointsPriceFilterFn = (data: FilterSourceItem, value: FilterData["pointsPrice"]): boolean => {
  if (value === -1) {
    return true;
  }
  return data.book_info?.points_rate <= value;
};
const cashRateFilterFn = (data: FilterSourceItem, value: FilterData["cashRate"]): boolean => {
  if (value === -1) {
    return true;
  }
  return data.book_info?.cash_rate <= value;
};
const distanceFilterFn = (data: FilterSourceItem, value: FilterData["distance"]): boolean => {
  if (value === -1) {
    return true;
  }
  return data.book_info?.distance <= value;
};
const gRatingFilterFn = (data: FilterSourceItem, value: FilterData["gRating"]): boolean => {
  if (value === -1) {
    return true;
  }
  return data.g_rating >= value;
};

const certificatesFilterFn = (
  data: FilterSourceItem,
  value: FilterData["certificates"]
): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.some((k) => data.book_info.certificates?.includes(k));
};

/**
 * 根据过滤条件筛选数据源
 * @param list
 * @param filter
 * @returns
 */
export const useFilterList = (list: FilterSourceData, filter: FilterData): FilterSourceData => {
  return list.filter((item) => {
    return [
      nameFilterFn(item, filter["name"]),
      brandFilterFn(item, filter["brand"]),
      subBrandFilterFn(item, filter["subBrand"]),
      banksFilterFn(item, filter["banks"]),
      pointsPriceFilterFn(item, filter["pointsPrice"]),
      cashRateFilterFn(item, filter["cashRate"]),
      distanceFilterFn(item, filter["distance"]),
      gRatingFilterFn(item, filter["gRating"]),
      certificatesFilterFn(item, filter["certificates"]),
    ].every(Boolean);
  });
};
